/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { FC, useState } from "react";
import _ from "lodash";
import DownloadLink from "./DownloadLink";
import FileMetadata from "./FileMetadata";
import upArrow from "../../assets/images/icons/up-arrow.svg";
import styles from "./download.module.scss";

export interface IArchiveDownloadSub {
  name: string;
  file_path: string;
  length: number;
  checksum: string;
}

export interface IArchiveDownload {
  name: string;
  file_path: string;
  length: string;
  checksum: string;
  subs: IArchiveDownloadSub[];
}

export interface IArchiveSection {
  name: string;
  description: string;
  isOpen: boolean;
  archives: IArchiveDownload[];
}

export interface IArchive {
  name: string;
  description: string;
  isOpen: boolean;
  type: "nuScenes" | "nuPlan" | "nuImages";
  subsets: IArchiveSection[] | IArchiveDownload[];
}

interface IProps {
  archives: IArchive[];
  archive: IArchive;
  archiveIndex: number;
  filesDownloading: any;
  regions: any;
  downloadingRegion: any;
  project: "nuScenes" | "nuPlan";
  downloadFile: (
    file: string,
    region: string,
    project: "nuScenes" | "nuPlan"
  ) => Promise<void>;
}

const Archive: FC<IProps> = (props: IProps) => {
  const {
    archives,
    archive,
    archiveIndex,
    filesDownloading,
    regions,
    downloadFile,
    project,
  } = props;
  const [count, setCount] = useState<number>(0);

  const toggleSection =
    (path) =>
    (e): void => {
      const section = _.get(archives, path, "");
      if (section) {
        section.isOpen = !section.isOpen;

        // ./Download.tsx uses something similar, but this essentially forces a re-render of the page
        // and usually shouldn't be used because we are using objects in an incorrect way here.
        setCount(count + 1);
      }
    };
  return (
    <div>
      <h3
        title="Click to toggle the content"
        className={styles.subtitle}
        onClick={toggleSection(archiveIndex)}
      >
        {archive.name}
        <img
          src={upArrow}
          alt="expand"
          className={archive.isOpen ? styles.expand : styles.collapsed}
        />
      </h3>
      {archive.isOpen && (
        <p
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: archive.description }}
        />
      )}
      <div>
        {archive.isOpen &&
          archive.subsets.map((subset, index) => (
            <div key={subset.name} className={styles.subsetBlock}>
              <div
                className={styles.release}
                onClick={toggleSection(`${archiveIndex}.subsets.${index}`)}
              >
                <span className={styles.subset}>{subset.name}</span>
                <div className={styles.upDownWrapper}>
                  <img
                    src={upArrow}
                    alt="minus"
                    className={subset.isOpen ? styles.up : styles.down}
                  />
                </div>
              </div>
              <p className={styles.text}>{subset.description}</p>
              {subset.isOpen &&
                subset.archives &&
                subset.archives.map((a, subIndex) => (
                  <div key={a.name}>
                    <div
                      className={`${styles.archiveLink} ${
                        a.subs && a.subs.length > 0 ? styles.hasSubs : ""
                      }`}
                    >
                      {a.subs && a.subs.length > 0 && (
                        <div
                          className={styles.upDownWrapper}
                          onClick={toggleSection(
                            `${archiveIndex}.subsets.${index}.archives.${subIndex}`
                          )}
                        >
                          <img
                            src={upArrow}
                            alt="plus"
                            className={a.isOpen ? styles.up : styles.down}
                          />
                        </div>
                      )}
                      <DownloadLink
                        fileName={a.name}
                        filePath={a.file_path}
                        filesDownloading={filesDownloading}
                        regions={regions}
                        downloadingRegion={undefined}
                        project={project}
                        downloadFile={downloadFile}
                      />
                      <FileMetadata file={a} />
                    </div>
                    <ul>
                      {a.isOpen &&
                        a.subs &&
                        a.subs.length > 0 &&
                        a.subs.map((b) => (
                          <li
                            key={b.name}
                            className={`flex-only vertical-center ${styles.indentedLink}`}
                          >
                            <DownloadLink
                              project={project}
                              fileName={b.name}
                              filePath={b.file_path}
                              filesDownloading={filesDownloading}
                              regions={regions}
                              downloadingRegion={undefined}
                              downloadFile={downloadFile}
                            />
                            <FileMetadata file={b} />
                          </li>
                        ))}
                    </ul>
                  </div>
                ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default Archive;
